import { FieldTemplateType, type ParticipantField } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { DateTime, P } from '@piccolohealth/util';
import React from 'react';

interface Props {
  field: ParticipantField;
}

export const ParticipantFieldValue = (props: Props) => {
  const { field } = props;

  if (P.isNil(field.value)) {
    return (
      <ChakraV3.Text fontSize='sm' color='gray.600'>
        N/A
      </ChakraV3.Text>
    );
  }

  switch (field.template.type) {
    case FieldTemplateType.Input:
      return (
        <ChakraV3.Text fontSize='sm' color='gray.600' whiteSpace='pre-wrap'>
          {field.template.attributes.prefix}
          {field.value}
          {field.template.attributes.suffix}
        </ChakraV3.Text>
      );
    case FieldTemplateType.Textarea:
    case FieldTemplateType.Select:
      return (
        <ChakraV3.Text fontSize='sm' color='gray.600' whiteSpace='pre-wrap'>
          {field.value}
        </ChakraV3.Text>
      );
    case FieldTemplateType.Datepicker:
      return (
        <ChakraV3.Text fontSize='sm' color='gray.600' whiteSpace='pre-wrap'>
          {DateTime.fromISO(field.value.toString()).toLocaleString(DateTime.DATE_SHORT)}
        </ChakraV3.Text>
      );
    case FieldTemplateType.MultiSelect:
      return (
        <ChakraV3.Text fontSize='sm' color='gray.600'>
          {!P.isEmpty(field.value) ? [field.value].flat().join(', ') : '-'}
        </ChakraV3.Text>
      );
  }
};
